import { useStyletron } from '@thanx/uikit/theme'
import palette from 'constants/palette'
import { buildTranslate } from 'locales'
import React from 'react'

const t = buildTranslate('locations.location_list')

const OrderingStatusBadge = ({ enabled }: { enabled: boolean }) => {
  const [css] = useStyletron()
  return (
    <span
      className={`d-inline-flex align-items-center px-s py-xxs ${css({
        backgroundColor: enabled ? palette.nephritis20 : palette.grey20,
        color: enabled ? palette.nephritis : palette.grey70,
        borderRadius: '4px',
        fontSize: '10px',
        fontWeight: 700,
        letterSpacing: '1px',
        textTransform: 'uppercase',
        lineHeight: '12px',
      })}`}
    >
      {enabled ? t('badge.ordering_enabled') : t('badge.ordering_disabled')}
    </span>
  )
}

export default OrderingStatusBadge
